var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 17.375V12.375H11.875V17.375H16.875V9.875C16.8751 9.7929 16.859 9.71159 16.8276 9.63572C16.7962 9.55985 16.7502 9.4909 16.6922 9.43282L10.4422 3.18282C10.3841 3.12471 10.3152 3.07861 10.2393 3.04715C10.1635 3.0157 10.0821 2.99951 10 2.99951C9.91787 2.99951 9.83654 3.0157 9.76066 3.04715C9.68479 3.07861 9.61586 3.12471 9.55781 3.18282L3.30781 9.43282C3.24979 9.4909 3.20378 9.55985 3.17241 9.63572C3.14105 9.71159 3.12494 9.7929 3.125 9.875V17.375H8.125Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default __webpack_public_path__ + "static/media/nav-home.2c06463f23e416fa256f1e2a4954a767.svg";
export { ForwardRef as ReactComponent };